import CannedNotes from './CannedNotes'

export default CannedNotes
